export default __webpack_public_path__ + "static/media/sustentacion_3.f82c4e68.jpg";